import { render } from "./AzadKashmir.vue?vue&type=template&id=18951619&scoped=true"
const script = {}

import "./AzadKashmir.vue?vue&type=style&index=0&id=18951619&scoped=true&lang=css"

import exportComponent from "/opt/buildhome/repo/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-18951619"]])

export default __exports__